<template>
  <va-card>
    <template slot="header">
      <div class="va-card__header-title" color="secondary">
        <router-link to="/">{{ $t('menu.dashboard') }}</router-link> / <router-link to="/ekstra/listesi">{{ $t('menu.vehicleExtras') }}</router-link> / {{ form.name_readable }}
      </div>
      <div class="va-card__header-actions"/>
    </template>
    <form @submit.prevent="onsubmit">
      <input type="hidden" v-model="form.language"/>
      <div class="row">
        <div class="flex md4 sm6 xs12">
          <va-input
            v-model="form.name"
            label="İsim [EN]"
            placeholder="Ekstra ismi çevirisi girin"
          />
        </div>
      </div>
      <div class="row">
        <div class="flex md8 sm12 xs12">
          <va-input
            type="textarea"
            :min-rows="4"
            v-model="form.description"
            label="Açıklama [EN]"
            placeholder="Ekstra açıklaması çevirisi girin"
          />
        </div>
      </div>
      <div class="row">
        <va-button type="submit">Kaydet</va-button>
      </div>
    </form>
  </va-card>
</template>

<script>
import vehicleExtraServices from '../../../services/api/vehicleExtra'
import responseMixin from '../../../services/api/response'
export default {
  mixins: [responseMixin],
  data () {
    return {
      form: {}
    }
  },
  methods: {
    async getVehicleExtra(id){
      const result = await vehicleExtraServices.get(id);
      if(result.error){
        return ;
      }
      this.form = result.data.data;
      this.form.language = 'en';
      this.form.name = this.form.name.en ? this.form.name.en : '';
      this.form.description =  !!this.form.description && this.form.description.en ? this.form.description.en : '';
    },
    async putVehicleExtra(id) {
      const res = await vehicleExtraServices.put(id, {
        data: this.form
      });
      if(res.error){
        //error handling
        this.responseToast('PUT', 'error', res);
        return ;
      }
      this.responseToast('PUT', 'success');
    },
    onsubmit () {
      //validation
      this.putVehicleExtra(this.$route.params.id);
    },
  },
  created () {
    if(this.$route.params.id) {
      this.getVehicleExtra(this.$route.params.id);
    }
  },
}
</script>